import $MD5 from 'crypto-js/md5';

export const MD5 = (d) => $MD5(d).toString().toLowerCase();

export const AvatarUri = (email, size) => {
    if (email == null) {
        return undefined;
    }
    let scale = window.devicePixelRatio;
    if (scale == null) {
        scale = 1.0;
    }
    const hash = MD5(email);
    return `https://www.gravatar.com/avatar/${hash}?s=${Math.round(size * scale)}&r=pg&d=robohash`;
};
